import { HttpClient, HttpContextToken } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { BehaviorSubject, filter, firstValueFrom, Observable, tap } from 'rxjs';
import { ResponseModel } from '../../models/base-response.model';
import { UserTerminal } from '../../models/lottery/users.models';
export const BYPASS_INTERCEPTOR = new HttpContextToken(() => false);
export const BYPASS_HANDLE_ERROR = new HttpContextToken(() => false);

@Injectable({
  providedIn: 'root'
})
export class UsersService extends BaseService<any> {

  public userTerminal = new BehaviorSubject<UserTerminal>(null as any);
  public userTerminal$ = this.userTerminal.asObservable().pipe(
    filter(userTerminal => userTerminal != null)
  );


  constructor(
    private _http: HttpClient,
  ) {
    super(_http, 'lottery/users');
  }

  async getCurrentUserTerminal() {
    const currentUserTerminal = await firstValueFrom(this.userTerminal$);
    return currentUserTerminal;
  }

  getTerminalUser(userId:string,serial:string): Promise<ResponseModel<UserTerminal>> {
    const url = `${this.baseUrl}/${userId}/terminals/${serial}`;

    return firstValueFrom(
      this._http.get<ResponseModel<UserTerminal>>(url)
    ).then(response => {
      this.userTerminal.next(response.data);
      return response;
    });
  }

  getTerminalUserAsObservable(userId: string, serial: string): Observable<ResponseModel<UserTerminal>> {
    const url = `${this.baseUrl}/${userId}/terminals/${serial}`;

    return this._http.get<ResponseModel<UserTerminal>>(url).pipe(
      tap(response => {
        this.userTerminal.next(response.data);
      })
    );
  }

}
